import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { Router } from './Router';
import { AppStylingProvider } from './theme';
import { LocaleProvider } from './translations/LocaleProvider';
import './index.css';

const App = () => {
  return (
    <Provider store={store}>
      <LocaleProvider>
        <AppStylingProvider>
          <Router />
        </AppStylingProvider>
      </LocaleProvider>
    </Provider>
  );
};

export default App;
